import { lang as langSV } from './sv-se';
import { lang as langEN } from './en';


/**
 * Lanagues supported.
 * They must be the same as set by language dropdown in site settings in WP.
 * Note, the keys must be in lowercase!
 */
export const translations: Record<string, Record<TranslationKeys, string>> = {
    'sv-se': langSV,
    'en': langEN,
};

/**
 * Translation keys to be used in the translation files.
 * Note, the keys must be in lowercase!
 * If you add a new key, it must be added to all translation files as well or it will fail to compile.
 */
export enum TranslationKeys {
    'show' = 'show',
    'hide' = 'hide',
    'content-for' = 'content-for',
    'submenu-for' = 'submenu-for',
    'follow-us-on' = 'follow-us-on',
    'written-by' = 'written-by',
    'all' = 'all',
    'load-more' = 'load-more',
    'filter-on' = 'filter-on',
    'minute-read' = 'minute-read',
    'form-sent' = 'form-sent',
    'form-error' = 'form-error',
    'captcha-required' = 'captcha-required',
    'captcha-failed' = 'captcha-failed',
    'captcha-unavailable' = 'captcha-unavailable',
    'accept-terms' = 'accept-terms',
    'is-required' = 'is-required',
    'last-name-invalid' = 'last-name-invalid',
    'first-name-invalid' = 'first-name-invalid',
    'email-invalid' = 'email-invalid',
    'zip-code-invalid' = 'zip-code-invalid',
    'phone-invalid' = 'phone-invalid',
    'see-our-projects' = 'see-our-projects',
    'news' = 'news',
    'press' = 'press',
    'close-menu' = 'close-menu',
    'find-something-good' = 'find-something-good',
    'search-hint' = 'search-hint',
    'found' = 'found',
    'hits' = 'hits',
    'go-to-homepage' = 'go-to-homepage',
    'twofour-blog-name' = 'twofour-blog-name',
    'twofour-blog-url' = 'twofour-blog-url',
    'search' = 'search',
    'show-menu' = 'show-menu',
    'open-search' = 'open-search',
    'copy-code-to-clipboard' = 'copy-code-to-clipboard',
    'twofour-slogan' = 'twofour-slogan',
    'post-type-page' = 'post-type-page',
    'post-type-news' = 'post-type-news',
    'post-type-blog' = 'post-type-blog',
    'post-type-project' = 'post-type-project',
    'post-type-client' = 'post-type-client',
    'code-copied-to-clipboard' = 'code-copied-to-clipboard',
    'read-more' = 'read-more',
    'primary-navigation' = 'primary-navigation',
    'secondary-navigation' = 'secondary-navigation',
    'no-results' = 'no-results',
}
